export default "__VITE_ASSET__DpH0MTVw__"